import {registerTemplateGraphNode} from "#template/template-node/register"
import {pointGeometryAttributeLike, pointGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {PointGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {UnaryMathOperatorParameters} from "#template/nodes/geometry-graph/attribute/unary-math-operator/geometry-unary-math-operator-node"
import {
    GeometryUnaryMathOperatorNode,
    unaryMathOperatorParametersSchema,
} from "#template/nodes/geometry-graph/attribute/unary-math-operator/geometry-unary-math-operator-node"

export type PointGeometryUnaryMathOperatorParameters = UnaryMathOperatorParameters<PointGeometryAttributeLikeNode>

const definition: TemplateNodeDefinition<PointGeometryUnaryMathOperatorParameters> = {
    nodeClass: "PointGeometryUnaryMathOperator",
    validation: {
        parameters: unaryMathOperatorParametersSchema(pointGeometryAttributeLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class PointGeometryUnaryMathOperator extends GeometryUnaryMathOperatorNode<0, PointGeometryAttributeLikeNode> implements PointGeometryAttributeLikeNode {
    get [pointGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
